function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgTelecommunications = function SvgTelecommunications(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 470.0159912109375 470.0159912109375",
    xmlSpace: "preserve",
    y: "0px",
    x: "0px",
    id: "Capa_1_1565754943258",
    width: 70,
    height: 67,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1, 1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M403.328,3.384l0-0.04c-2.601-3.572-7.604-4.359-11.176-1.758c-3.528,2.569-4.346,7.49-1.84,11.063     c47.595,66.618,47.595,156.118,0,222.736c-2.582,3.586-1.768,8.585,1.818,11.167c0.015,0.011,0.031,0.022,0.047,0.033     c3.593,2.564,8.583,1.733,11.152-1.856C454.901,172.546,454.901,75.567,403.328,3.384z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.841,1.489c0,0-0.001,0-0.001-0.001c-3.593-2.564-8.583-1.733-11.152,1.856c-51.573,72.183-51.573,169.161,0,241.344     c2.601,3.572,7.604,4.359,11.176,1.758c3.528-2.569,4.346-7.49,1.84-11.062c-47.595-66.618-47.595-156.118,0-222.736     C80.271,9.052,79.437,4.056,75.841,1.489z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.72,40.704c2.706-3.492,2.069-8.518-1.424-11.224c0,0,0,0,0,0c-3.48-2.697-8.486-2.075-11.2,1.392     c-42.741,54.741-42.741,131.547,0,186.288c2.715,3.486,7.742,4.111,11.228,1.396s4.111-7.742,1.396-11.228     C88.48,158.369,88.48,89.664,126.72,40.704z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.722,29.479c0,0-0.001,0.001-0.001,0.001c-3.467,2.714-4.089,7.72-1.392,11.2     c38.241,48.959,38.241,117.665,0,166.624c-2.715,3.486-2.09,8.513,1.396,11.228s8.513,2.09,11.228-1.396     c42.741-54.741,42.741-131.547,0-186.288C351.229,27.369,346.201,26.756,342.722,29.479z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.248,69.288c29.013,30.718,29.013,78.738,0,109.456c-3.029,3.217-2.876,8.28,0.34,11.309     c0.001,0.001,0.002,0.002,0.004,0.003c3.219,3.027,8.282,2.871,11.308-0.348c0.001-0.001,0.002-0.003,0.004-0.004     c34.804-36.877,34.804-94.499,0-131.376c-3.001-3.243-8.063-3.438-11.305-0.437c-3.243,3.001-3.438,8.063-0.437,11.305     C292.19,69.227,292.219,69.258,292.248,69.288z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.936,192.224c4.418,0.002,8.002-3.578,8.004-7.996c0.001-2.038-0.776-3.999-2.172-5.484     c-29.013-30.718-29.013-78.738,0-109.456c3.052-3.195,2.936-8.259-0.259-11.311c-3.195-3.052-8.259-2.936-11.311,0.259     c-0.029,0.03-0.058,0.061-0.086,0.092c-34.804,36.877-34.804,94.499,0,131.376C165.623,191.311,167.73,192.223,169.936,192.224z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.768,458.024l-77.896-303.752c16.852-14.284,18.933-39.525,4.649-56.377c-14.284-16.852-39.525-18.933-56.377-4.649     c-16.852,14.284-18.933,39.525-4.649,56.377c1.419,1.675,2.974,3.23,4.649,4.649l-77.888,303.752     c-1.101,4.279,1.476,8.64,5.755,9.741c0.004,0.001,0.009,0.002,0.013,0.003c0.649,0.164,1.315,0.247,1.984,0.248     c3.65-0.002,6.835-2.473,7.744-6.008l2.672-10.4c0.448-0.127,0.884-0.293,1.304-0.496L299.272,372.4l22.976,89.6     c0.907,3.544,4.102,6.021,7.76,6.016c0.672,0,1.341-0.083,1.992-0.248c4.281-1.093,6.865-5.45,5.771-9.731     C337.77,458.033,337.769,458.029,337.768,458.024z M260.64,221.696l-43.504-38.072l5.504-21.456     c3.678,1.171,7.508,1.793,11.368,1.848c3.859-0.055,7.69-0.677,11.368-1.848L260.64,221.696z M234.008,100.016     c13.255,0,24,10.745,24,24s-10.745,24-24,24s-24-10.745-24-24S220.753,100.016,234.008,100.016z M212.688,200.984l48.184,42.176     l-71.2,47.44L212.688,200.984z M153.728,430.912l28.72-112l97.6,45.536L153.728,430.912z M194.28,306.784l75.304-50.208     l24.856,96.944L194.28,306.784z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  })))), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTelecommunications, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/telecommunications.6f58d2e9.svg";
export { ForwardRef as ReactComponent };